<template>
  <div class="h-full relative">
    <div class="w-full h-full relative">
      <MapComponent ref="mapComponent" @userCoordinateGot="onUserPositionGot" />
    </div>

    <div
      class="w-full absolute bottom-0 bg-white z-[2] h-full duration-500 ease-in-out"
      :class="{
        'translate-y-[calc(100%-135px)]': !searchInterfaceVisible,
        'translate-y-[0px]': searchInterfaceVisible,
      }"
    >
      <div
        class="px-6 pb-80 duration-300"
        :class="{
          'pointer-events-none opacity-0': searchInterfaceVisible,
        }"
      >
        <div
          class="absolute bottom-[99%] w-full h-[1rem] left-0"
          style="background: linear-gradient(to top, #ffffff 5%, #0000)"
        ></div>
        <div class="absolute bottom-full right-6">
          <div
            class="w-16 h-16 bg-white rounded-2xl ripple shadow-b-xl p-4"
            @click="selectCurrentUserGeoPosition"
          >
            <img src="@/assets/images/all/target.svg" alt="" />
          </div>
        </div>
        <div class="py-1"></div>
        <div
          class="text-md text-primary border-b-2 border-primary-200 flex justify-between items-end ripple py-2 px-1"
          @click="searchInterfaceVisible = true"
        >
          <div class="">
            {{ selectedLocation.formatted || selectedLocation.name }}
          </div>
          <div class="w-6 h-6">
            <img src="@/assets/images/all/pen-primary.svg" alt="" />
          </div>
        </div>
        <div class="py-2"></div>
        <button
          class="text-lg buttonComponent w-full py-5"
          @click="confirmLocation"
        >
          Confirmer la localisation
        </button>
      </div>
      <LocationAutocompletRequester
        v-if="searchInterfaceVisible"
        :text="locationSearchText"
        @searching="
          () => {
            isSearchingLocation = true
          }
        "
        @result="
          data => {
            locationAutoCompletResult = data
            isSearchingLocation = false
          }
        "
      />
      <div
        class="absolute h-full w-full top-0 duration-300"
        :class="{
          'pointer-events-none opacity-0': !searchInterfaceVisible,
        }"
      >
        <div class="py-2"></div>
        <div class="px-6">
          <InputComponent
            type="search"
            v-model="locationSearchText"
            prefix="<img src='/images/icons/search.svg' class='w-8 h-8'>"
            placeHolder="Rechercher"
            class="[&_.prefix]:!opacity-100 shadow-sm !mt-0 duration-300 [&_.prefix]:!duration-300"
          />
        </div>
        <!-- <button class="buttonComponent" @click="initSearch">clos</button> -->
        <div class="h-[calc(100%-80px)] overflow-auto">
          <div
            class="border-b py-4 flex px-6 items-center gap-1 text-sm ripple"
            v-for="location in isSearchingLocation
              ? [{}, {}, {}, {}, {}]
              : locationAutoCompletResult"
            @click="selectAutocompletedPosition(location)"
            :class="{
              'shimmerElementRoundedDefault mb-2': isSearchingLocation,
            }"
          >
            <div class="w-[2rem] min-w-[2rem] h-[2rem]">
              <img src="@/assets/images/all/location.svg" alt="" />
            </div>
            <div class="w-[calc(100%)-2rem] truncate">
              <span class="title-color">
                {{ location.name }}
              </span>
              &nbsp;
              <span class="description-color">
                {{ location.formatted }}
              </span>
            </div>
          </div>
        </div>
        <!-- {{ locationAutoCompletResult }} -->
        <!-- {{ isSearchingLocation }} -->
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import MapComponent from './MapComponent.vue'
import LocationAutocompletRequester from './LocationAutocompletRequester.vue'
import InputComponent from '../utils/InputComponent.vue'

export default defineComponent({
  name: 'LocationSelector',
  components: { MapComponent, LocationAutocompletRequester, InputComponent },
  props: {},
  data() {
    return {
      searchInterfaceVisible: false,
      isSearchingLocation: false,
      locationSearchText: '',
      locationAutoCompletResult: [],
      selectedLocation: {},
      actualUserPosition: {
        actualUserPosition: true,
        name: 'Ma position actuelle',
      },
    }
  },
  mounted() {
    console.log('map')
  },
  unmounted() {},
  methods: {
    initMap() {
      this.selectCurrentUserGeoPosition()
      this.$refs.mapComponent.initMap()
    },
    initSearch() {
      this.locationSearchText = ''
      this.locationAutoCompletResult = []
      this.searchInterfaceVisible = false
    },
    selectCurrentUserGeoPosition() {
      this.selectedLocation = { ...this.actualUserPosition }
      this.$refs.mapComponent.centerToUserPosition()
      console.log(this.actualUserPosition)
      if (this.actualUserPosition.lon) {
        this.$refs.mapComponent.createMarker(
          this.actualUserPosition.lon,
          this.actualUserPosition.lat,
          'locationToAdd',
        )
      }
    },
    selectAutocompletedPosition(location) {
      if (this.isSearchingLocation) return
      this.selectedLocation = location
      this.searchInterfaceVisible = false
      this.$refs.mapComponent.createMarker(
        location.lon,
        location.lat,
        'locationToAdd',
      )
    },
    onUserPositionGot(data) {
      this.actualUserPosition.lon = data.longitude
      this.actualUserPosition.lat = data.latitude
      console.log(data, this.actualUserPosition)
      if (this.selectedLocation.actualUserPosition) {
        this.selectedLocation = { ...this.actualUserPosition }
        this.$refs.mapComponent.createMarker(
          this.actualUserPosition.lon,
          this.actualUserPosition.lat,
          'locationToAdd',
        )
      }
    },
    async confirmLocation() {
      await this.updateSelectedLocationInfos()
    },
    async updateSelectedLocationInfos() {
      const markedCoordinates =
        this.$refs.mapComponent.getMarkerCoordinates('locationToAdd')
      const markedCoordinatesLon = this.$Commons.round(
        markedCoordinates.longitude,
        4,
      )
      const markedCoordinatesLat = this.$Commons.round(
        markedCoordinates.latitude,
        4,
      )
      const selectedCoordinatesLon = this.$Commons.round(
        this.selectedLocation.lon || 0,
        4,
      )
      const selectedCoordinatesLat = this.$Commons.round(
        this.selectedLocation.lat || 0,
        4,
      )
      if (
        markedCoordinatesLon == selectedCoordinatesLon &&
        markedCoordinatesLat == selectedCoordinatesLat
      )
        return
      const coordinateDetails = await this.$Events.sendDataRequestResolve(
        'coordinateDetails',
        { longitude: markedCoordinatesLon, latitude: markedCoordinatesLat },
        9999999999,
      )
      this.selectedLocation = {
        ...this.selectedLocation,
        ...coordinateDetails,
      }
    },
  },
  watch: {},
})
</script>

<style></style>
